import Swiper from 'swiper';
import { Thumbs } from 'swiper';
import Modal from './modals';
document.querySelectorAll('.image-series').forEach(section => {
    const showMoreButton = section.querySelector('.btn-show-more');
    if (showMoreButton) {
        const modal = new Modal(section.querySelector('.modal'));
        const sliderContainer = section.querySelector('.image-slider');
        const thumbSliderContainer = section.querySelector('.thumbs-slider');
        // A modal should be available in the mobile view of the page
        showMoreButton.addEventListener('click', () => {
            modal.open();
        });
        const thumbsSwiper = new Swiper(thumbSliderContainer, {
            slidesPerView: 3,
            spaceBetween: 16,
            freeMode: true,
            watchSlidesProgress: true,
        });
        new Swiper(sliderContainer, {
            slidesPerView: 1,
            modules: [Thumbs],
            thumbs: {
                swiper: thumbsSwiper,
            },
        });
        // Attach close actions
        ['.modal-bg-fade', '.btn.is-modal-close'].forEach(selector => {
            section.querySelector(selector)?.addEventListener('click', () => {
                modal.close();
            });
        });
    }
});
